// index.ts
import { useEffect, useLayoutEffect, useRef } from "react";
import sync, { cancelSync } from "framesync";
import { flushSync, getFrameData } from "framesync";
var isServer = typeof window === "undefined";
var useIsomorphicLayoutEffect = isServer ? useEffect : useLayoutEffect;
function useFrame(callback, {
  enabled = true,
  once = false,
  type = "update"
} = {}) {
  const callbackRef = useRef();
  callbackRef.current = callback;
  useIsomorphicLayoutEffect(() => {
    const cancel = () => {
      process && cancelSync[type](process);
      initialTimestamp = null;
    };
    let initialTimestamp = null;
    let process;
    if (enabled) {
      process = sync[type](({ delta, timestamp }) => {
        if (!initialTimestamp) {
          initialTimestamp = timestamp;
        }
        callbackRef.current({
          elapsed: timestamp - initialTimestamp,
          cancel,
          delta,
          timestamp
        });
      }, !once);
    }
    return () => {
      if (process) {
        cancelSync[type](process);
      }
    };
  }, [enabled]);
}
export {
  cancelSync,
  flushSync,
  getFrameData,
  sync,
  useFrame
};
